import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';

import { createReduxStore } from '../../../shared/utils/redux';
import { IApplicationState, IThunkContext } from '../../../shared/types/redux';
import { createMicrofrontendsAPI } from '../microfrontends';

export function createApplicationState() {
  const config = getConfig();
  const httpApi = getHttpApi();
  const logger = getLogger();

  const context: IThunkContext = { config, httpApi, logger, microfrontendsAPI: createMicrofrontendsAPI() };

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(initialState, true, context);
}
